
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import api from '~api'
export default {
name: "pay-success",
components: {
XHeader,Group,Selector,Toast
},
data() {
return {
title: "选择宿舍类型",
grade:"2018",
checkeddorm:'',
dormtype:[],
dormAttrValue:'',
dormAttrOptions:[],
dormAttrName:'',
showDormAttr: window.localStorage.getItem("isNew") === "1" && window.localStorage.getItem("enrollType") === "2",
showBool:false,
editBool:false,
showtoast:false,
toasttext:'',
welBool: true
}
},
mounted(){
api.post( '/api/dormitoryType/stuDormitoryType',{"stuCode":window.localStorage.getItem('stuCode')}).then(res => {
if(res.data.results!=null){
this.checkeddorm = res.data.results.housetypeName;
this.dormAttrValue = res.data.results.remark || '';
this.editBool = true;
if(this.showDormAttr){ this.getDormAttrDict(); }
}else {
this.getDormData();
if(this.showDormAttr){ this.getDormAttrDict(); }
}
}).catch( err =>{
this.$msgbox('温馨提示：',"系统错误！");
});
},
methods:{
getDormData(){
api.post( '/api/dormitoryType/QueryDormitoryType',{"stuCode":window.localStorage.getItem('stuCode')}).then(res => {
if(res.status == 200){
for(var i=0;i<res.data.results.length;i++){
var obj = {};
this.$set(obj,"key",res.data.results[i].roomType);
this.$set(obj,"value",res.data.results[i].housetypeName);
this.dormtype.push(obj);
}
}else{
this.$msgbox('温馨提示：',"系统错误！");
}
}).catch( err =>{
this.$msgbox('温馨提示：',"系统错误！");
});
},
getDormAttrDict(){
api.post('/api/dormitoryType/queryDict',{"keyValue":"112"}).then(res => {
if(res.data && res.data.code === "0"){
var list = res.data.results || [];
list.sort(function(a,b){
var oa = a.orderNum == null ? Number.MAX_SAFE_INTEGER : Number(a.orderNum);
var ob = b.orderNum == null ? Number.MAX_SAFE_INTEGER : Number(b.orderNum);
return oa - ob;
});
for(var i=0;i<list.length;i++){
var obj = {};
this.$set(obj,"key",list[i].keyValue);
this.$set(obj,"value",list[i].name);
this.dormAttrOptions.push(obj);
}
if(this.editBool && this.dormAttrValue){
for(var j=0;j<this.dormAttrOptions.length;j++){
if(this.dormAttrOptions[j].key == this.dormAttrValue){
this.dormAttrName = this.dormAttrOptions[j].value;
break;
}
}
} else if(!this.editBool && this.dormAttrOptions.length > 0){
this.dormAttrValue = this.dormAttrOptions[0].key;
}
}
}).catch( err =>{
this.$msgbox('温馨提示：',"住宿偏好加载失败");
});
},
onSubmit(){
if(this.checkeddorm==="" || this.checkeddorm===null){
this.$msgbox('温馨提示：',"请选择宿舍类型");
return;
}
var params = {
"stuCode":window.localStorage.getItem('stuCode'),
"housetype":this.checkeddorm,
"remark":this.dormAttrValue,
"processId":this.$route.params.sort
};
api.post( '/api/dormitoryType/insert',params).then(res => {
if(res.data.code==="0"){
this.next();
}else{
this.$msgbox('温馨提示：',res.data.result);
}
}).catch( err =>{
this.$msgbox('温馨提示：',"系统错误！");
});
},
next(){
var _this = this;
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));



/*_this.$vux.loading.show({
text: 'Loading'
})
welcomeapi.welcomepost('/NewReports/addInformation',
{
"stuCode":_this.$store.state.stu_num,
"stuName":_this.stuinfo.name,
/!*"stuCode":'1801010122',
"stuName":'皮皮虾',*!/
"weChat":_this.stuinfo.wechat,
"email":_this.stuinfo.email,
"phone":_this.stuinfo.phone,
"dName":_this.stuinfo.dname,
"dRelation":_this.stuinfo.drelate,
"dPhone":_this.stuinfo.dphone,
"mName":_this.stuinfo.mname,
"mRelation":_this.stuinfo.mrelate,
"mPhone":_this.stuinfo.mphone
}
).then(function (response) {
var data = response.data;
console.log(response.data);

if (data.result == true){
_this.$vux.loading.hide()
_this.$router.push({name: 'schoolInformation'});
}else {
_this.$msgbox('温馨提示：',"您的信息不完善");
_this.$vux.loading.hide()
}
})*/
var sort = _this.$route.params.sort;
var urlname = '';
var stunum = _this.$route.params.stunum;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort>sort){
sort = flowdata[i].sort;
urlname = flowdata[i].urlname;
_this.$router.push({name: urlname,params:{sort:sort,stunum:stunum}});
return;
}/*else{
_this.$router.push({name: 'generateform',params:{stunum:stunum}});
}*/
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/selectdorm.vue